import { createMuiTheme } from '@material-ui/core/styles';
import colors from './Colors';

const defaultTheme = createMuiTheme();

export default createMuiTheme({
  typography: {
    fontFamily: 'Helvetica',
    h3: {
      fontSize: 16,
      color: colors.text,
    },
    h4: {
      fontSize: 14,
      color: colors.text,
    },
    h5: {
      fontSize: 14,
      fontWeight: 'bold',
      color: colors.text,
    },
    h6: {
      fontSize: 12,
      color: colors.text,
    },
    body1: {
      paddingTop: 10,
      paddingBottom: 10,
      fontSize: 14,
      fontWeight: 'bold',
      color: colors.text,
    },
    body2: {
      fontSize: 14,
      color: colors.text,
    },
    subtitle1: {
      fontSize: 14,
      color: colors.secondaryText,
      lineHeight: 1.235,
    },
  },
  overrides: {
    MuiAvatarGroup: {
      avatar: {
        width: 48,
        height: 48,
      },
    },
    MuiAvatar: {
      img: {
        height: 'auto',
      },
    },
    MuiLink: {
      root: {
        fontWeight: '600 !important',
        color: colors.text,
        cursor: 'pointer',
      },
    },
    MuiSkeleton: {
      root: {
        marginBottom: 8,
      },
    },
    MuiMenuItem: {
      root: {
        paddingTop: 14,
        paddingBottom: 14,
        paddingRight: 24,
        fontSize: 14,
        '&:hover': {
          backgroundColor: colors.hoverMenu,
        },
      },
    },
    MuiIconButton: {
      root: {
        color: colors.secondaryText,
        padding: 4,
      },
      sizeSmall: {
        fontSize: 20,
        padding: 0,
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: 20,
        cursor: 'pointer',
        marginBottom: '0 !important',
      },
      colorError: {
        color: colors.errorRed,
      },
      colorPrimary: {
        color: colors.secondaryText,
      },
      colorAction: {
        color: 'inherit',
        fontSize: '24px !important',
      },
    },
    MuiTabs: {
      root: {
        paddingLeft: 8,
        paddingRight: 8,
      },
    },
    MuiTab: {
      root: {
        padding: 0,
      },
    },
    MuiButton: {
      outlinedPrimary: {
        backgroundColor: colors.buttons.blueBg,
        borderColor: colors.buttons.blueBorder,
      },
      outlinedSecondary: {
        backgroundColor: colors.buttons.redBg,
        borderColor: colors.buttons.redBorder,
      },
      label: {
        textTransform: 'none',
        color: colors.buttons.activeColor,
      },
      containedPrimary: {
        marginTop: 0,
        backgroundColor: colors.buttons.containedBg,
        boxShadow: 'none',
        '& span': {
          color: colors.buttons.white,
        },
      },
      colorInherit: {
        backgroundColor: 'transparent',
        marginTop: 0,
        marginBottom: 8,
        marginLeft: 0,
        marginRight: 8,
        boxShadow: 'none',
        padding: '6px 16px',
        '& span': {
          color: colors.headerText,
          fontWeight: 'bold',
        },
        '&:focus, &:hover': {
          backgroundColor: colors.hoverMenu,
          boxShadow: 'none',
        },
        '&.active': {
          backgroundColor: colors.hoverMenu,
        },
        '&.active:hover': {
          backgroundColor: colors.buttons.lightHover,
        },
        [defaultTheme.breakpoints.down('xs')]: {
          padding: 8,
          '& span': {
            flexDirection: 'column',
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        },
        '&:last-child': {
          marginEnd: '0',
        },
      },
      startIcon: {
        [defaultTheme.breakpoints.down('xs')]: {
          margin: '0 0 8px 0',
          display: 'flex',
          justifyContent: 'center',
        },
      },
      outlined: {
        padding: '5px 14.5px',
        marginLeft: 0,
        marginRight: 7.46,
        [defaultTheme.breakpoints.down('xs')]: {
          width: 'calc(50% - 4px)',
          '&:nth-child(even)': {
            marginEnd: '0px',
          },
        },
      },
    },
    MuiDialog: {
      paper: {
        [defaultTheme.breakpoints.down('xs')]: {
          margin: 8,
        },
      },
    },
    MuiDialogContent: {
      root: {
        maxHeight: 400,
        maxWidth: '100%',
        border: 'none',
        [defaultTheme.breakpoints.down('xs')]: {
          padding: '8px 16px 16px 16px',
          width: 'inherit',
        },
      },
      dividers: {
        width: 480,
        border: 'none',
        borderTop: 'none',
        [defaultTheme.breakpoints.down('xs')]: {
          padding: '8px 16px 16px 16px',
          width: 'inherit',
        },
      },
    },
    MuiDialogTitle: {
      root: {
        margin: 0,
        padding: '16px 24px',
        [defaultTheme.breakpoints.down('xs')]: {
          padding: 16,
        },
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        paddingLeft: '16px !important',
        paddingRight: '0px !important',
      },
      input: {
        padding: '7px 4px !important',
        minWidth: '0px !important',
      },
    },
    MuiGrid: {
      root: {
        '& .MuiButton-outlined:last-child': {
          marginEnd: '0px',
        },
      },
    },
    MuiInputBase: {
      root: {
        fontSize: 14,
        color: colors.headerText,
        whiteSpace: 'pre-line',
        lineHeight: '130%',
        fontWeight: 400,
      },
    },
    MuiCard: {
      root: {
        border: '1px solid #e7e7e7',
        overflow: 'unset',
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: '#252A31',
        color: colors.buttons.white,
        padding: '8px 12px',
        fontSize: 12,
      },
      tooltipArrow: {
        backgroundColor: '#252A31',
      },
    },
  },
  palette: {
    activeColor: '#333333',
  },
});
